import './App.css';
import 'core/services/amplify';

import React, { useEffect } from 'react';

import { Box } from '@mui/material';

import { useTrackingInit } from 'services/tracking/hooks';

import { SuccessModal } from 'components/Modals/SuccessModal';

import { ConfirmationModal } from 'components/Modals/ConfirmationModal';
import { Drawer } from 'components/Drawer/Drawer';
import { LoadingOverlay } from 'components/Loading/LoadingOverlay';
import { FormModal } from 'components/Modals/FormModal';
import { InputConfirmationModal } from 'components/Modals/InputConfirmationModal';
import { AppNavigator } from 'AppNavigator';
import { ErrorBoundary } from 'components/ErrorBoundary';
import { Toast, BottomDrawer } from 'common/ui';
import { Loading } from 'common/ui/Loading';
import { useAuth } from 'services/auth/hooks';
import { DrawerV2 } from 'common/drawer/components/DrawerV2';
import { ModalV2 } from 'common/modal/components/ModalV2';
import { OrganizationChangeListener } from 'services/organization/OrganizationChangeListener';
import { ActionBar } from 'common/actionBar/components/ActionBar';
import { usePylonWidget } from 'core/services/pylon/usePylonWidget';

function App() {
  useTrackingInit();
  const { checkUser, isLoading } = useAuth();
  usePylonWidget();

  useEffect(() => {
    // Check if user is authenticated and fetch initial data on app load.
    checkUser();
  }, []);

  if (isLoading) {
    return (
      <Box
        component="main"
        sx={{
          width: '100%',
          overflow: 'auto',
          height: '100%',
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center'
        }}
      >
        <Loading />
      </Box>
    );
  }

  return (
    <Box
      component="main"
      sx={{ width: '100%', overflow: 'auto', height: '100%' }}
    >
      <OrganizationChangeListener />
      <ErrorBoundary>
        <AppNavigator />
      </ErrorBoundary>
      <Toast />
      <ModalV2 />
      <ConfirmationModal />
      <LoadingOverlay />
      <FormModal />
      <SuccessModal />
      <InputConfirmationModal />
      <Drawer />
      <DrawerV2 />
      <ActionBar />
      <BottomDrawer />
    </Box>
  );
}

export default App;
